<template>
  <div
    :class="$style.container"
    :data-percent="value"
    :style="{ height: `${height}px` }"
  >
    <svg
      :class="$style.progress"
      :width="width"
      :height="height"
      viewport="0 0 100 100"
    >
      <circle :class="$style.meter" :r="radius" :cx="x" :cy="y"></circle>

      <circle
        :class="$style.bar"
        :r="radius"
        :cx="x"
        :cy="y"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="(circumference * value) / 100"
      ></circle>
    </svg>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class RadialProgressBar extends Vue {
  @Prop({ type: Number, default: 10 }) public value!: number;
  @Prop({ type: Number, default: 100 }) public width!: number;
  @Prop({ type: Number, default: 100 }) public height!: number;

  public radius: number = 30;

  get x(): number {
    return this.width / 2;
  }

  get y(): number {
    return this.height / 2;
  }

  // Full circle =  2 * π * radius
  public circumference = 2 * Math.PI * this.radius;
}
</script>
<style lang="scss" module>
.container {
  margin: 0;
  height: 100%;
  position: relative;

  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 14px;
    transform: translate(-50%, -50%);
  }
}

.progress {
  display: block;
  margin: 0 auto;
  overflow: hidden;
  transform: rotate(-90deg) rotateX(180deg);
  animation: progressSpinner 2s linear infinite;
  -webkit-animation: progressSpinner 2s linear infinite;
  -moz-animation: progressSpinner 2s linear infinite;
  -ms-animation: progressSpinner 2s linear infinite;
  -o-animation: progressSpinner 2s linear infinite;

  circle {
    stroke-width: 3px;
    fill: transparent;
    transition: stroke-dashoffset 1s ease;
  }

  .meter {
    stroke: white;
  }

  .bar {
    stroke: $primary;
  }
}

@keyframes progressSpinner {
  from {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
  }
}
</style>
